<template>
    <v-col cols="12" sm="6" lg="6" :class="setClass()">
        <v-card class="background-2 round-card" style="height: 100%">
            <v-card-text class="pa-0">
                <div class="pa-4">Task / Durata</div>
            <v-divider></v-divider>
            </v-card-text>                
            <v-data-table
                class="background-2"
                :headers="headers"
                :items="items"
                :search="search"
                :loading="loading"
                :mobile-breakpoint="0"
                :footer-props="{
                    'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
                }">
                <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                    <tr class="cursor-pointer" @click="$eventBusUtility.goTo($router, 'tasks', item.id)">
                        <template v-for="(header, h) in headers">
                            <td :key="h" v-if="header.value == 'duration'">
                                {{ item[header.value] | duration}}
                            </td>
                            <td :key="h" v-else-if="header.value == 'users'">
                                <template v-for="(user, u) in item[header.value]">
                                    <v-avatar v-if="$store.getters.avatars[user]" :key="u"
                                        :size="30"
                                        class="custom-avatar-table"
                                        :style="{'background-image': 'url(' + $store.getters.avatars[user] + ')'}">
                                    </v-avatar>
                                    <v-avatar v-else :class="$eventBusUtility.bgColor(user)" :size="30" class="custom-avatar-table" :key="u">
                                        <span class="white--text fs12 " v-if="user">{{ $store.getters.users[user].value.charAt(0) }}</span>
                                    </v-avatar>
                                </template>

                            </td>
                            <td :key="h" v-else>
                                {{ item[header.value]}}
                            </td>
                        </template>
                    </tr>
                </template>
                <template v-slot:footer.page-text="{ pageStart, pageStop }">
                    Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                </template>
            </v-data-table>
        </v-card>
    </v-col>
</template>

<script>

    export default {
        name: 'tasks-duration',
        props: {
            id: Number,
        },

        data() {
            return {
                items: [],
                totalItems: 0,
                loading: false,
                pagination: {},
                search: '',
                subFilters: {},
                headers: [
                    {
                        text: 'Task',
                        value: 'title',
                    },
                    {
                        text: 'Utenti',
                        value: 'users',
                    },
                    {
                        text: 'Durata',
                        value: 'duration',
                    },
                ]
            }
        },

        methods: {
            initialize() {
                this.loading = true
                this.axios.post('tasks-duration/' + this.id).then(response => {
                    this.items = response.data.data
                    this.totalItems = this.items.length
                    this.$store.commit('endProgress')
                    this.loading = false

                }, response => {
                    // error callback
                })                
            },

            setClass() {
                if(this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
                    return 'pa-0 pl-2'
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    return 'pa-0 pr-0 pl-2'
                }
                if(this.$vuetify.breakpoint.xs) {
                    return 'pa-0 pt-4'
                }
            },
        },
        
        mounted() {
            this.$eventBusUtility.$on('updatedTaskboard', () => {
                this.initialize()
            })
        },

        created() {
            this.initialize()
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('updatedTaskboard')
		}, 
    }
</script>
<style>

    .custom-avatar-table {
        margin-left: -7px;
        height: 26px;
        border-width: 2px!important;
        border: 2px solid white;
        min-width: 26px;
        width: 26px;
        height: 26px;
        min-width: 26px;
        width: 26px;
        border-radius: 50% !important;
        background-size: cover !important;
        background-position: center !important;
    }

</style>